import { ContestDto } from '../../../interfaces/dtos/ContestDto';
import { ContestInformation } from '../../../interfaces/ContestInformation';

export default function transformContest(data: ContestDto): ContestInformation {
  return {
    title: data.title,
    description: data.description,
    contestRulesUri: data.contestRulesUri,
    unsubscribeConfirmationMessage: data.unsubscribeConfirmationMessage,
    summary: data.summary,
    isActive: data.isActive,
    promoterCode: data.promoterCode,
  };
}
